"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconUploadSquareSolid = exports.IconUploadSquare = exports.IconSearchAnimated = exports.IconBack = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _withLoadingIndicator = _interopRequireDefault(require("./withLoadingIndicator"));

var _index = require("./index");

var IconBack = function IconBack(props) {
  return /*#__PURE__*/_react["default"].createElement(_index.IconChevron, (0, _extends2["default"])({
    direction: "left"
  }, props));
};

exports.IconBack = IconBack;
var IconSearchAnimated = (0, _withLoadingIndicator["default"])(_index.IconSearch);
exports.IconSearchAnimated = IconSearchAnimated;

var IconUploadSquare = function IconUploadSquare(props) {
  return /*#__PURE__*/_react["default"].createElement(_index.IconDownloadSquare, (0, _extends2["default"])({
    style: {
      transform: 'rotate(180deg)'
    }
  }, props));
};

exports.IconUploadSquare = IconUploadSquare;

var IconUploadSquareSolid = function IconUploadSquareSolid(props) {
  return /*#__PURE__*/_react["default"].createElement(_index.IconDownloadSquareSolid, (0, _extends2["default"])({
    style: {
      transform: 'rotate(180deg)'
    }
  }, props));
};

exports.IconUploadSquareSolid = IconUploadSquareSolid;